/**
 * Leitura por conversa guardada no navegador. O backend não expõe leitura por
 * utilizador, por isso a marca é local: o mesmo critério do app mobile.
 */
const KEY = "7days:chat:lastReadAt";

type LastRead = Record<string, number>;

export const CHAT_READ_EVENT = "7days:chat-read";

export function loadReadState(): LastRead {
    try {
        const raw = window.localStorage.getItem(KEY);
        return raw ? (JSON.parse(raw) as LastRead) : {};
    } catch {
        return {};
    }
}

export function markTopicRead(topicId: string, atMs: number = Date.now()): void {
    try {
        const next = { ...loadReadState(), [topicId]: atMs };
        window.localStorage.setItem(KEY, JSON.stringify(next));
        window.dispatchEvent(new CustomEvent(CHAT_READ_EVENT, { detail: topicId }));
    } catch {
        // Marca perdida só faz a conversa voltar a aparecer por ler.
    }
}

interface LastMessageLike {
    senderId?: string;
    sentAt?: string;
}

export function hasUnread(lastMessage: LastMessageLike | undefined, lastReadMs: number | undefined, currentUserId: string): boolean {
    if (!lastMessage?.sentAt || !lastMessage.senderId) return false;
    if (String(lastMessage.senderId) === String(currentUserId)) return false;
    const sent = Date.parse(lastMessage.sentAt);
    if (Number.isNaN(sent)) return false;
    return lastReadMs === undefined || sent > lastReadMs;
}
